export function sanitizeSearchKey(searchKey: string) {
    return searchKey
        .trim() // Remove spaces from the front and back
        .replace(/[^a-zA-Z0-9\s]+/g, "-") // Replace one or more special characters with a hyphen
        .replace(/\s+/g, "-") // Replace spaces with hyphens
        .replace(/-+/g, "-") // Replace multiple consecutive hyphens with a single hyphen
        .replace(/^-|-$/g, "") // Remove hyphens from the start and end
        ?.toLowerCase(); // Convert the entire string to lowercase
}